import React, { useState } from 'react';
import moment from 'moment';
import config from "../../../../../config";
import { useLocation, useNavigate } from 'react-router';
import { NotificationListApi, NotificationUpdateApi } from 'store/slices/notificationSlice';
import { useSelector, useDispatch } from 'react-redux';
import MoonLoader from "react-spinners/MoonLoader";
import { usercheckAccess } from 'helpers/Functions';
import customToast from 'component/Toastr';
import { useTranslation } from 'react-i18next';
import { openCancelledBookingInvoice, openOnlineBookingNotification } from './notificationOnlineBookingActions';
import {
  getBookingCanceledByText,
  getNotificationInvoiceNumber,
  hasRefundPending,
  isAppointmentCancelled,
  resolveAppointmentCancelledBy,
} from 'helpers/cancellationDisplay';
import { InvoiceRedirectLoading } from 'store/slices/clientinvoiceSlice';

const BookingNotificationList = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [loader, setLoader] = useState({});
  const [refundLoader, setRefundLoader] = useState({});
  const views = props && props.view;
  const viewData = views && views.data ? views.data : views;
  const objectData = viewData && viewData.length > 0
    ? viewData.filter((item) => item.type === "online_booking" || item.type === "waitlist_offer" || item.type === "waitlist_left" || item.type === "waitlist_joined" || item.type === "waitlist_confirmed")
    : [];
  const auth = useSelector((state) => state.auth);
  const currentUser = auth.user;
  const role_id = currentUser && currentUser.role_id;
  const single_staff_access = usercheckAccess("calendar_view", currentUser);
  const singleStaffAccess = role_id === 8 ? '' : (single_staff_access && currentUser && currentUser.is_owner === 0) ? 1 : '';

  return (
    <div>
      {objectData && objectData.length > 0 ? (
        <>
          {Object.keys(objectData).map((item, index) => {
            const id = objectData[item] && objectData[item].id ? objectData[item].id : "";
            const isWaitlistOffer = objectData[item]?.type === "waitlist_offer";
            const isWaitlistLeft = objectData[item]?.type === "waitlist_left";
            const isWaitlistJoined = objectData[item]?.type === "waitlist_joined";
            const isWaitlistConfirmed = objectData[item]?.type === "waitlist_confirmed";
            const appointment = objectData[item]?.appointment || {};
            const notificationClient = objectData[item]?.client || {};
            const waitlist = objectData[item]?.waitlist || {};
            const profilePhotoUrl = appointment?.client?.profile_photo_url || notificationClient?.profile_photo_url || "";
            const first_name = appointment?.client?.first_name || notificationClient?.first_name || "";
            const last_name = appointment?.client?.last_name || notificationClient?.last_name || "";
            const iconUrl = isWaitlistLeft || isWaitlistConfirmed || objectData[item]?.type === "online_booking" ? "eye-round.png" : objectData[item]?.type === "message" ? "reply-round.png" : "";
            const datedifference = objectData[item]?.created_at ? moment(objectData[item].created_at, "YYYY-MM-DD hh:mm:ss").fromNow() : "";
            const dateof = appointment?.dateof
              ? moment(appointment.dateof, "YYYY-MM-DD").format("DD/MM/YYYY")
              : (waitlist?.preferred_date ? moment(waitlist.preferred_date, "YYYY-MM-DD").format("DD/MM/YYYY") : "");
            const service_name = appointment?.service?.name || waitlist?.service_name || "";
            const appointment_time = (appointment?.start_time && appointment?.end_time)
              ? (`${moment(appointment.start_time, "HH:mm:ss").format("hh:mm A")} - ${moment(appointment.end_time, "HH:mm:ss").format("hh:mm A")}`)
              : "";
            const is_seen = objectData[item] && objectData[item].is_seen == 0 ? 0 : 1;
            const staff_first_name = appointment?.staff?.first_name || waitlist?.staff_first_name || "";
            const staff_last_name = appointment?.staff?.last_name || waitlist?.staff_last_name || "";
            const waitlistStaffName = waitlist?.staff_name || `${staff_first_name} ${staff_last_name}`.trim() || "Any staff";
            const isCancelled = !isWaitlistOffer && !isWaitlistLeft && !isWaitlistJoined && !isWaitlistConfirmed && isAppointmentCancelled(appointment);
            const canceledByText = getBookingCanceledByText(resolveAppointmentCancelledBy(appointment));
            const invoiceNumber = getNotificationInvoiceNumber(appointment);
            const refundPending = hasRefundPending(appointment);

            return (
              <div className="box-image-cover notification-boxs w-100 mx-0 py-md-4 py-3 text-start" style={{ background: `${is_seen == 1 ? "#fff" : "#f9f6f4"}`,marginBottom:`${index === objectData.length - 1 ? "43px" : "0px"}`  }} key={index}>
                <div className="row align-items-center">
                  <div className="col-xxl-9 col-md-8 mb-md-0 mb-2">
                    <div className="d-flex align-items-center">
                      <div className="text-center">
                        {profilePhotoUrl ? (
                          <img src={profilePhotoUrl} alt="" className="rounded-circle wh-40 profile-image-obj mwh-40" />
                        ) : (
                          <div className="user-initial text-uppercase profile-image-height wh-40 mwh-40">{first_name && last_name && first_name.charAt(0) + "" + last_name.charAt(0)}</div>
                        )}
                      </div>
                      <div className="ps-3">
                        <div>
                          <h6 className='fw-semibold mb-0'>{`${first_name} ${last_name}`}</h6>
                        </div>
                        <div>
                          {isWaitlistOffer ? (
                            <>
                              <p className='fw-semibold mb-0 color-wine'>{t("Waitlist spot offered")}</p>
                              <p className='fw-semibold mb-0'>{`${service_name} with ${staff_first_name + " " + staff_last_name}`}</p>
                              <p className='fw-semibold mb-0'>{dateof}</p>
                              <div>
                                <span className='text-dark'>{appointment_time}</span>
                              </div>
                              <p className='mb-0'>{t("Client has 15 minutes to confirm.")}</p>
                            </>
                          ) : isWaitlistConfirmed ? (
                            <>
                              <p className='fw-semibold mb-0 color-wine'>{t("Waitlist booking confirmed")}</p>
                              <p className='fw-semibold mb-0'>{`${service_name} with ${staff_first_name + " " + staff_last_name}`}</p>
                              <p className='fw-semibold mb-0'>{dateof}</p>
                              <div>
                                <span className='text-dark'>{appointment_time}</span>
                              </div>
                            </>
                          ) : isWaitlistJoined ? (
                            <>
                              <p className='fw-semibold mb-0 color-wine'>{t("Joined waitlist")}</p>
                              <p className='fw-semibold mb-0'>{`${service_name} with ${waitlistStaffName}`}</p>
                              {dateof ? <p className='fw-semibold mb-0'>{dateof}</p> : null}
                              <p className='mb-0'>{t("Preferred time")}: {waitlist?.preferred_time ? (waitlist.preferred_time === "morning" ? t("Morning") : waitlist.preferred_time === "afternoon" ? t("Afternoon") : waitlist.preferred_time) : t("Any time")}</p>
                            </>
                          ) : isWaitlistLeft ? (
                            <>
                              <p className='fw-semibold mb-0 color-wine'>{t("Left waitlist")}</p>
                              {service_name ? (
                                <p className='fw-semibold mb-0'>{`${service_name} with ${staff_first_name + " " + staff_last_name}`}</p>
                              ) : (
                                <p className='mb-0'>{t("Client removed themselves from the waitlist.")}</p>
                              )}
                              {dateof ? <p className='fw-semibold mb-0'>{dateof}</p> : null}
                              {appointment_time ? (
                                <div>
                                  <span className='text-dark'>{appointment_time}</span>
                                </div>
                              ) : null}
                            </>
                          ) : (
                            <>
                              <p className='fw-semibold mb-0'>{`${service_name} with ${staff_first_name + " " + staff_last_name}`}</p>
                              <p className='fw-semibold mb-0'>{dateof}</p>
                              <div>
                                <span className='text-dark'>{appointment_time}</span>
                              </div>
                              {invoiceNumber ? (
                                <p className='fw-semibold mb-0'>{t("Invoice")} {invoiceNumber}</p>
                              ) : null}
                              {isCancelled ? (
                                <div>
                                  <p className='mb-0 text-danger'>{t("Status")}: {t("Cancelled")}</p>
                                  {canceledByText ? (
                                    <p className='mb-0 text-danger'>{t(canceledByText)}</p>
                                  ) : (
                                    <p className='mb-0 text-danger'>{t("The appointment has been canceled.")}</p>
                                  )}
                                </div>
                              ) : null}
                            </>
                          )}
                          <div>
                            <span className='color-wine'>{datedifference}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-md-4 ps-md-0 d-flex justify-content-end align-items-center gap-2 flex-wrap">
                    {isCancelled && refundPending ? (
                      <button
                        type="button"
                        className="btn btn-apricots btn-sm"
                        disabled={!!refundLoader[index]}
                        onClick={async (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setRefundLoader((prev) => ({ ...prev, [index]: true }));
                          dispatch(InvoiceRedirectLoading(true));
                          try {
                            const updateAction = await dispatch(NotificationUpdateApi({ id, is_seen: 1 }));
                            if (updateAction.meta.requestStatus === "fulfilled") {
                              dispatch(NotificationListApi());
                            }
                            await openCancelledBookingInvoice({
                              dispatch,
                              t,
                              notificationItem: objectData[item],
                            });
                          } catch (error) {
                            customToast.error(t("Sorry there was a problem, please refresh your browser"));
                            dispatch(InvoiceRedirectLoading(false));
                          } finally {
                            setRefundLoader((prev) => ({ ...prev, [index]: false }));
                          }
                        }}
                      >
                        {refundLoader[index] ? (
                          <MoonLoader color="#8c1c4d" size="16px" />
                        ) : (
                          t("Refund")
                        )}
                      </button>
                    ) : null}
                    {isCancelled ? null : (
                      <>
                        {iconUrl ? (
                          <span
                            onClick={async () => {
                              setLoader((prevLoader) => ({ ...prevLoader, [index]: true }));

                              try {
                                const updateAction = await dispatch(NotificationUpdateApi({ id, is_seen: 1 }));
                                if (updateAction.meta.requestStatus === "fulfilled") {
                                  dispatch(NotificationListApi());
                                }

                                if (!isWaitlistLeft && !isWaitlistOffer && !isWaitlistJoined) {
                                  await openOnlineBookingNotification({
                                    dispatch,
                                    navigate,
                                    location,
                                    t,
                                    notificationItem: objectData[item],
                                    singleStaffAccess,
                                  });
                                }
                              } catch (error) {
                                customToast.error(t("Sorry there was a problem, please refresh your browser"));
                              } finally {
                                setLoader((prevLoader) => ({ ...prevLoader, [index]: false }));
                              }
                            }}>
                            {loader[index] ? (
                              <MoonLoader color="#8c1c4d" size="22px" />
                            ) : (
                              <img src={config.imagepath + iconUrl} alt="" className="rounded-circle wh-25 profile-image-obj" />
                            )}
                          </span>
                        ) : ""}
                      </>
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        </>
      ) : (
        <div className="complete-box text-center d-flex flex-column justify-content-center mt-5">
          <div className="complete-box-wrp text-center">
            <img src={config.imagepath + "notification-bell.png"} alt="" className="mb-md-4 mb-3" />
            <h5 className="mb-2 fw-semibold" style={{ color: 'rgb(151,136,136)' }}>{t("No notification found")}</h5>
          </div>
        </div>
      )}
    </div>
  )
}

export default BookingNotificationList;
